import {
    LOCAL_STORAGE_ACTIVE,
    LOCAL_STORAGE_CREATED_ID,
    LOCAL_STORAGE_CREATED_TECH_MAP_ID,
    LOCAL_STORAGE_START_PATH,
    LOCAL_STORAGE_STEP,
    LOCAL_STORAGE_TYPE,
} from "./constants";
import { useNavigate } from "react-router-dom";
import { WarehouseTutorialType } from "../../../utils/enums";

interface CleanupConfig {
    [stepIndex: number]: string[];
}

export enum StepDirection {
    NEXT = 1,
    PREV = -1,
}

export const moveStepInLocalStorage = (direction: StepDirection): number => {
    const current = Number(localStorage.getItem(LOCAL_STORAGE_STEP) ?? 0);
    const next = current + direction;
    localStorage.setItem(LOCAL_STORAGE_STEP, String(next));
    return next;
};

export const setStepInLocalStorage = (step: number) => {
    localStorage.setItem(LOCAL_STORAGE_STEP, String(step));
};

export const getWarehouseTutorialType = (): WarehouseTutorialType | null => {
    return (localStorage.getItem(LOCAL_STORAGE_TYPE) as WarehouseTutorialType) || null;
};

export const getCurrentStepFromLocalStorage = (): number => {
    return Number(localStorage.getItem(LOCAL_STORAGE_STEP) ?? 0);
};

export const isWarehouseTutorialActive = (): boolean => {
    return localStorage.getItem(LOCAL_STORAGE_ACTIVE) === "true";
};

export const stepCleanupMap: CleanupConfig = {
    2: [LOCAL_STORAGE_CREATED_ID], // in step 2 we clear the created ID
};

export const finishTutorial = (branchId: string, navigate: ReturnType<typeof useNavigate>) => {
    localStorage.removeItem(LOCAL_STORAGE_ACTIVE);
    localStorage.removeItem(LOCAL_STORAGE_STEP);
    localStorage.removeItem(LOCAL_STORAGE_TYPE);
    localStorage.removeItem(LOCAL_STORAGE_CREATED_ID);
    localStorage.removeItem(LOCAL_STORAGE_CREATED_TECH_MAP_ID);

    // return to the page you started from
    const startPath = localStorage.getItem(LOCAL_STORAGE_START_PATH);
    if (startPath) {
        localStorage.removeItem(LOCAL_STORAGE_START_PATH);
        navigate(startPath);
    } else {
        navigate(`/branches/main/branch/${branchId}`);
    }
};

export const abortTutorial = () => {
    localStorage.removeItem(LOCAL_STORAGE_ACTIVE);
    localStorage.removeItem(LOCAL_STORAGE_STEP);
    localStorage.removeItem(LOCAL_STORAGE_TYPE);
    localStorage.removeItem(LOCAL_STORAGE_CREATED_ID);
    localStorage.removeItem(LOCAL_STORAGE_CREATED_TECH_MAP_ID);
};
